import { render, staticRenderFns } from "./VipLevel.vue?vue&type=template&id=24e4685e&scoped=true&"
import script from "./VipLevel.vue?vue&type=script&lang=js&"
export * from "./VipLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e4685e",
  null
  
)

export default component.exports